<template>
  <div class="main">
    <div style="position:fixed; top : 0; z-index:999">
      <div
        style="height:70px; width:1440px; background: #14E056; display: flex; justify-content: space-between; align-items: center;"
      >
		<img src=".././assets/img/img_head_luckybot_logo@2x.png" alt class="topLogo" />
		<span class="topIntro">有困惑 上助我</span>
		</div>
    </div>

    <div class="main_0">
      <div style="position: relative; margin-top:70px">
        <img class="topImg" alt="Vue logo" src=".././assets/img/Rectangle Copy 4@2x.png" />
        <span class="title">心灵聊天机器人</span>
        
      <div class="bear">
        <img
          style="width: 340px;height: 180px;"
          alt="Vue logo"
          src=".././assets/img/img_bear@2x.png"
        />
      </div>
            </div>
<div style="height: 400px;"></div>
    </div>
   
    

    <div class="bottomdir">
      <div style="margin-top:35px; color:white; fontSize:12px; display: flex; align-items: center; opacity:0.5">
		<!-- www.chentuanbazi.com www.chentuanziwei.com -->
		<!-- <span @click="goMiitWeb" style="cursor: pointer;color: #282525;">顺物文化创意 Copyright © 2022</span> -->
		<!-- www.chentuanbazi.com -->
		<!-- <span @click="goMiitWeb" style="cursor: pointer;color: #282525;">顺物文化创意 Copyright © 2022 皖ICP备2022009364号-2</span> -->
		<!-- www.chentuanziwei.com -->
		<span @click="goMiitWeb" style="cursor: pointer;color: #282525;">顺物文化创意 Copyright © 2022 皖ICP备2022009364号-1</span>
		<!-- www.xiaoxinli.net -->
		<!-- <span @click="goMiitWeb" style="cursor: pointer;color: #282525;">助我科技 Copyright © 2022 京ICP备2022016331号</span>
			<img
			style="width:12px; height:12px;margin-left:4px;margin-right:4px"
			src=".././assets/img/batb.png"
		/> -->
		<!-- <span @click="goGAWeb" style="cursor: pointer;color: #282525;">皖公网安备34011102001567号</span>	 -->
	</div>
    </div>
  </div>
</template>

<script>

export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  mounted() {},
  methods: {
    goMiitWeb(){
       window.location.href = "https://beian.miit.gov.cn";
    },
    goGAWeb(){
      window.location.href = "http://www.beian.gov.cn/portal/registerSystemInfo";
    },
    download(){
      console.log("go download");
      window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.tianxun.zhuwo";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {
	width: 100%;
  width: 1440px;
  /* width: 80%; */
  /* background-color: green; */
  left: 0px;
  right: 0px;
  margin: 0 auto;
}

/* .main_0
{
    position: absolute;
} */

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  /* display: inline-block; */
  margin: 0 10px;
}
a {
  color: #42b983;
}

.topImg {
  width: 100%;
  z-index: 1;
}

.topLogo {
  margin-left: 240px;
  z-index: 10;
  width: 120px;
  height: 40px;
}

.topIntro {
  z-index: 10;
  margin-right: 250px;
  /* top: 25px; */
  color: white;
  letter-spacing: 8px;
}

.title {
  position: absolute;
  z-index: 10;
  /* margin: 0 auto; */
  top: 100px;
  left: 0;
  right: 0;
  color: white;
  font-size: 50px;
  font-weight: bold;
}

.data {
  position: absolute;
  z-index: 10;
  /* margin: 0 auto; */
  color: white;
  font-weight: bold;
}

.dataMid {
  top: 240px;
  left: 0;
  right: 0;
  font-size: 36px;
}

.dataLeft {
  top: 240px;
  left: 420px;
  /* right: 0; */
  font-size: 36px;
}

.dataRight {
  top: 240px;
  right: 384px;
  font-size: 36px;
}

.bear {
  position: absolute;
  z-index: 10;

  left: 0;
  right: 0;
  top: 420px;
}

.detailDiv {
  margin-top: 160px;
  width: 100%;
  position: relative;
}

.chatImg {
  width: 470px;
  height: 360px;
  /* background-color: lightcoral; */
  margin: 0 auto;
  margin-left: 480px;
}

.quoteImg {
  width: 62px;
  height: 62px;
  left: 240px;
  top: 0px;
  position: absolute;
}

.detailText {
  width: 388px;
  left: 312px;
  top: 30px;
  position: absolute;
  font-size: 18px;
  color: #282525;
  line-height: 28px;
  text-align: left;
}

.detaiFlex {
  display: flex;
  /* justify-content: space-between;
  align-items: center; */
  align-items: flex-start;
  align-content: flex-start;
  margin-top: 160px;
  justify-content: center;
}

.midContent {
  margin-left: 23px;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-content: flex-start;
}

.appIcon {
  /* margin-left: 403px; */
  margin-top: 0px;
  width: 140px;
  height: 140px;
}

.flexDetailText {
  width: 470px;
  font-size: 18px;
  color: #282525;
  line-height: 28px;
  text-align: left;
  margin-top: 40px;
}

.downloadBtn {
  margin-top: 30px;
  background-color: #14e056;
  font-size: 18px;
  color: white;
  width: 184px;
  height: 56px;
  border-radius: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.contentBottom {
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: center;
  margin-top: 160px;
  width: 100%;
}

.bottomTitle {
  font-size: 40px;
  color: #282525;
  font-weight: bold;
  text-align: left;
  width: 100%;
}

.bottomdir {
  background-color: #ffffff;
  height: 80px;
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
</style>
